import * as React from "react";

const Account: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="-1 -1 28 28"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fill="#424242"
                fillRule="evenodd"
                d="M13 0c7.18 0 13 5.82 13 13s-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0zm0 1.17C6.477 1.17 1.17 6.477 1.17 13S6.477 24.83 13 24.83 24.83 19.523 24.83 13 19.523 1.17 13 1.17zm.001 12.597a9.055 9.055 0 017.968 4.746.558.558 0 01-.05.604 9.98 9.98 0 01-7.918 3.89 9.986 9.986 0 01-7.921-3.89.558.558 0 01-.05-.604 9.056 9.056 0 017.971-4.746zm0-9.213a4.118 4.118 0 110 8.236 4.118 4.118 0 010-8.236z"
            />
        </svg>
    );
};

export default React.memo(Account);
